import { Fragment, type ReactNode } from "react";
import { useParams } from "react-router-dom";

/**
 * Each order gets its own page: moving from one order to another starts the page afresh, so
 * nothing opened on the last one — a cancellation waiting to be confirmed, an answer, a message —
 * carries over to act on, or speak for, the next (I2.1).
 */
export function OneOrderPerPage({ children }: { children: ReactNode }) {
  const { physicalOrderId = "" } = useParams<{ physicalOrderId: string }>();
  return <Fragment key={physicalOrderId}>{children}</Fragment>;
}
